// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"f51aa7c0","215":"b5cc18ea","257":"80d88449","364":"ca02a8a3"}[chunkId] + ".chunk.css";
};